import { SignUpContainer } from '@containers/auth';

export function SignUp() {
  return <SignUpContainer />;
}
